import { atom } from 'jotai';

export const isMenuOpenAtom = atom(false);
isMenuOpenAtom.debugLabel = 'isMenuOpen';

export const activeNavItemAtom = atom(null);
activeNavItemAtom.debugLabel = 'activeNavItem';

export const activeNavSubItemAtom = atom(null);
activeNavSubItemAtom.debugLabel = 'activeNavSubItem';

export const isNavExpandedAtom = atom(false);
isNavExpandedAtom.debugLabel = 'isNavExpanded';

export const selectedNavTitleAtom = atom(undefined);
isNavExpandedAtom.debugLabel = 'selectedNavTitle';
